import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { map } from 'lodash';
import { Row } from 'react-bootstrap';
import ParameterSection from './Sections/ParameterSection';
import './style.scss';

const TrendSignalKPIListComponent = (props) => {
    const { model, actions } = props;

    useEffect(() => {
        actions.getTrendKPIListForAsset(props.asset);
    }, [props.asset]);

    const sectionKpi = [{ data: model?.trendKPIsList }];

    return (
        <>
            {sectionKpi?.length ?
                <Row className='trend-kpi-list measurement-list-container'>
                    {
                        map(sectionKpi, (kpiSection) => {
                            return <ParameterSection
                                key={kpiSection.sectionId}
                                section={kpiSection}
                                selectedTrendsData={model.selectedTrendsData}
                                asset={props.asset} />;
                        })
                    }
                </Row> : null}

        </>
    );
};

TrendSignalKPIListComponent.propTypes = {
    actions: PropTypes.shape({
        getTrendKPIListForAsset: PropTypes.func, // Function to fetch the trend KPI list for the asset
    }), // Actions object containing functions
    asset: PropTypes.shape({
        id: PropTypes.string, // Asset ID
        name: PropTypes.string, // Asset name
    }), // Asset details
    model: PropTypes.shape({
        trendKPIsList: PropTypes.arrayOf(
            PropTypes.shape({
                sectionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Section ID
                data: PropTypes.arrayOf(
                    PropTypes.shape({
                        timeseriesKey: PropTypes.string, // Unique key for the timeseries
                        label: PropTypes.string, // Label for the KPI
                        unit: PropTypes.string, // Unit of the KPI
                        displayValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Last measurement value
                        isPlottableToTrendChart: PropTypes.bool, // Whether the KPI can be plotted on the trend chart
                        limitStatus: PropTypes.string, // Status of the limit
                    })
                ), // Array of KPI data
            })
        ), // Array of trend KPI sections
        trendKPIsLoadingStatus: PropTypes.string, // Loading status of the trend KPIs
        selectedTrendsData: PropTypes.arrayOf(
            PropTypes.shape({
                config: PropTypes.shape({
                    timeseriesKey: PropTypes.string, // Timeseries key of the selected trend
                }),
            })
        ), // Array of selected trends data
    }), // Model containing state data
};

export default TrendSignalKPIListComponent;
